/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DeviceActivityType {
    None = 0,
    Display = 10,
    ExamStudentOutsidePc = 11,
    ExamExaminerPc = 12,
    ExamStandardizedPatientPc = 13,
    ExamStudentInsidePc = 14,
    Player = 100,
    Recorder = 1000,
    ExamConfirmation = 1001,
    ExamMasterOfCeremony = 1002,
    Tablet = 1003,
    ViewingStation = 1004,
    TrainingRoomPc = 1005,
    PeerPracticeStudent = 1006,
    PeerPracticeMasterOfCeremony = 1007,
    MultiRoomRecordingMasterOfCeremony = 1008,
    RoomAccess = 2001,
}
